// TOP カテゴリスライダーアロー（PCのみ）
(function () {
  var grid = document.getElementById('categoryGrid');
  if (!grid) return;

  var prevBtn = document.querySelector('.category__arrow--prev');
  var nextBtn = document.querySelector('.category__arrow--next');
  if (!prevBtn || !nextBtn) return;

  function getScrollAmount() {
    var card = grid.querySelector('.category-card');
    if (!card) return 330;
    var style = window.getComputedStyle(grid);
    var gap = parseFloat(style.columnGap) || 30;
    return card.offsetWidth + gap;
  }

  function updateArrows() {
    prevBtn.disabled = grid.scrollLeft <= 1;
    nextBtn.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 1;
  }

  prevBtn.addEventListener('click', function () {
    grid.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', function () {
    grid.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
  });

  grid.addEventListener('scroll', updateArrows, { passive: true });
  updateArrows();
})();

// PC PRODUCT dropdown
(function () {
  const productBtn   = document.getElementById('productNavBtn');
  const dropdown     = document.getElementById('productDropdown');
  const overlay      = document.getElementById('dropdownOverlay');

  if (!productBtn || !dropdown) return;

  function openDropdown() {
    document.dispatchEvent(new CustomEvent('mii:closeHeaderSearch'));
    dropdown.classList.add('is-open');
    dropdown.setAttribute('aria-hidden', 'false');
    productBtn.setAttribute('aria-expanded', 'true');
    productBtn.classList.add('is-active');
    overlay.classList.add('is-active');
  }

  function closeDropdown() {
    dropdown.classList.remove('is-open');
    dropdown.setAttribute('aria-hidden', 'true');
    productBtn.setAttribute('aria-expanded', 'false');
    productBtn.classList.remove('is-active');
    overlay.classList.remove('is-active');
  }

  productBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    if (productBtn.tagName && productBtn.tagName.toLowerCase() === 'a') {
      e.preventDefault();
    }
    dropdown.classList.contains('is-open') ? closeDropdown() : openDropdown();
  });

  overlay.addEventListener('click', closeDropdown);
  document.addEventListener('mii:closeHeaderProductDropdown', closeDropdown);

  document.addEventListener('click', function (e) {
    if (!dropdown.classList.contains('is-open')) return;
    if (productBtn.contains(e.target) || dropdown.contains(e.target)) return;
    closeDropdown();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && dropdown.classList.contains('is-open')) {
      closeDropdown();
      productBtn.focus();
    }
  });
})();

// Product search: keep the submitted query clean while relying on Shopify prefix search.
(function () {
  var generatedQuerySelector = 'input[type="hidden"][name="q"][data-partial-search-query="true"]';

  function buildProductSearchQuery(value) {
    return getDisplaySearchValue(value);
  }

  function getDisplaySearchValue(value) {
    var cleanValue = value.replace(/\*/g, '').trim();
    var taggedTermPattern = /\(([^()]*?)\s+OR\s+tag:"(?:\\"|[^"])*"\)/g;
    var displayTerms = [];
    var match;

    while ((match = taggedTermPattern.exec(cleanValue)) !== null) {
      if (match[1]) {
        displayTerms.push(match[1].trim());
      }
    }

    return displayTerms.length ? displayTerms.join(' ') : cleanValue;
  }

  function ensureDisplayInput(form) {
    var displayInput = form.querySelector('input[name="display_q"]');
    if (displayInput) return displayInput;

    displayInput = document.createElement('input');
    displayInput.type = 'hidden';
    displayInput.name = 'display_q';
    form.appendChild(displayInput);
    return displayInput;
  }

  function updateSearchDisplayFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var displayValue = params.get('display_q') || params.get('q');

    if (!displayValue) return;

    displayValue = getDisplaySearchValue(displayValue);
    if (!displayValue) return;

    document.querySelectorAll('form[role="search"]').forEach(function (form) {
      var searchInput = form.querySelector('input[type="search"][name="q"]');
      var displayInput = form.querySelector('input[name="display_q"]');

      if (searchInput) searchInput.value = displayValue;
      if (displayInput) displayInput.value = displayValue;
    });

    document.querySelectorAll('[data-search-display-term]').forEach(function (el) {
      el.textContent = displayValue;
    });
  }

  document.querySelectorAll('form[role="search"]').forEach(function (form) {
    var searchInput = form.querySelector('input[type="search"][name="q"]');
    var productTypeInput = form.querySelector('input[name="type"][value="product"]');

    if (!searchInput || !productTypeInput) return;

    form.addEventListener('submit', function () {
      var displayValue = getDisplaySearchValue(searchInput.value);
      if (!displayValue) return;

      var displayInput = ensureDisplayInput(form);
      var generatedQueryInput = form.querySelector(generatedQuerySelector);
      var originalName = searchInput.getAttribute('name');

      displayInput.value = displayValue;

      if (!generatedQueryInput) {
        generatedQueryInput = document.createElement('input');
        generatedQueryInput.type = 'hidden';
        generatedQueryInput.name = 'q';
        generatedQueryInput.setAttribute('data-partial-search-query', 'true');
        form.appendChild(generatedQueryInput);
      }

      generatedQueryInput.value = buildProductSearchQuery(displayValue);
      searchInput.removeAttribute('name');

      window.setTimeout(function () {
        searchInput.setAttribute('name', originalName || 'q');
        if (generatedQueryInput.parentNode) {
          generatedQueryInput.parentNode.removeChild(generatedQueryInput);
        }
      }, 0);
    });
  });

  updateSearchDisplayFromUrl();
})();

// Header product search
(function () {
  const searchBtn = document.getElementById('headerSearchToggle');
  const searchPanel = document.getElementById('headerSearchPanel');
  const searchInput = document.getElementById('HeaderSearchInput');

  if (!searchBtn || !searchPanel) return;

  function openSearch() {
    document.dispatchEvent(new CustomEvent('mii:closeHeaderProductDropdown'));
    searchPanel.classList.add('is-open');
    searchPanel.setAttribute('aria-hidden', 'false');
    searchBtn.setAttribute('aria-expanded', 'true');
    window.requestAnimationFrame(function () {
      if (searchInput) searchInput.focus();
    });
  }

  function closeSearch() {
    searchPanel.classList.remove('is-open');
    searchPanel.setAttribute('aria-hidden', 'true');
    searchBtn.setAttribute('aria-expanded', 'false');
  }

  searchBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    searchPanel.classList.contains('is-open') ? closeSearch() : openSearch();
  });

  searchPanel.addEventListener('click', function (e) {
    e.stopPropagation();
  });

  document.addEventListener('click', function () {
    if (searchPanel.classList.contains('is-open')) closeSearch();
  });
  document.addEventListener('mii:closeHeaderSearch', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchPanel.classList.contains('is-open')) {
      closeSearch();
      searchBtn.focus();
    }
  });
})();

// Cart count badge
(function () {
  function normalizeCount(value) {
    var count = parseInt(value, 10);
    return Number.isFinite(count) && count > 0 ? count : 0;
  }

  function updateCartCount(count) {
    var normalizedCount = normalizeCount(count);
    document.querySelectorAll('[data-cart-count-badge]').forEach(function (badge) {
      badge.textContent = String(normalizedCount);
      badge.classList.toggle('is-hidden', normalizedCount === 0);
    });

    document.querySelectorAll('a[href="/cart"], a[href$="/cart"]').forEach(function (link) {
      link.setAttribute(
        'aria-label',
        normalizedCount > 0 ? 'カート、商品' + normalizedCount + '点' : 'カート'
      );
    });
  }

  document.addEventListener('mii:cart-count-update', function (event) {
    if (!event.detail) return;
    updateCartCount(event.detail.item_count);
  });

  document.addEventListener('cart:updated', function (event) {
    if (!event.detail) return;
    var itemCount = typeof event.detail.item_count !== 'undefined'
      ? event.detail.item_count
      : event.detail.cart && event.detail.cart.item_count;
    updateCartCount(itemCount);
  });

  window.miiUpdateCartCount = updateCartCount;
})();

// SP パネル（PRODUCT ドロップダウン / メニュードロワー）— 相互排他制御
(function () {
  var productBtn = document.getElementById('bottomNavProduct');
  var dropdown   = document.getElementById('spProductDropdown');
  var dropOverlay = document.getElementById('spDropdownOverlay');

  var menuBtn  = document.getElementById('bottomNavMenu');
  var drawer   = document.getElementById('spMenuDrawer');
  var menuOverlay = document.getElementById('spMenuOverlay');

  function closeDropdown() {
    if (!dropdown) return;
    dropdown.classList.remove('is-open');
    dropdown.setAttribute('aria-hidden', 'true');
    if (productBtn) productBtn.setAttribute('aria-expanded', 'false');
    if (dropOverlay) dropOverlay.classList.remove('is-active');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    if (menuOverlay) menuOverlay.classList.remove('is-active');
  }

  function openDropdown() {
    closeDrawer();
    dropdown.classList.add('is-open');
    dropdown.setAttribute('aria-hidden', 'false');
    productBtn.setAttribute('aria-expanded', 'true');
    dropOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function openDrawer() {
    closeDropdown();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    menuBtn.setAttribute('aria-expanded', 'true');
    menuOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeAll() {
    closeDropdown();
    closeDrawer();
    document.body.style.overflow = '';
  }

  if (productBtn && dropdown) {
    productBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      dropdown.classList.contains('is-open') ? closeAll() : openDropdown();
    });
    dropOverlay.addEventListener('click', closeAll);
    dropdown.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeAll);
    });
  }

  if (menuBtn && drawer) {
    menuBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      drawer.classList.contains('is-open') ? closeAll() : openDrawer();
    });
    menuOverlay.addEventListener('click', closeAll);
    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeAll);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();

// 注釈記号（*1, *2 など）を上付き文字に変換（全ページ共通）
(function () {
  var SELECTORS = [
    '.product-about__heading',
    '.feature-card__title',
    '.feature-card__desc',
    '.feature-card__footnote',
    '.product-scent__desc',
    '.product-scent__heading-ja',
    '.product-scent__heading',
    '.product-specs__value',
    '.step-card__desc',
    '.product-about__desc',
    '.product-about__footnote',
  ];
  function applySupSub(el) {
    if (!el || !el.innerHTML) return;
    if (el.querySelector('.footnote-sup')) return;
    el.innerHTML = el.innerHTML.replace(/\*(\d+)/g, '<sup class="footnote-sup">*$1</sup>');
  }

  function applyNoteMarker(el) {
    if (!el || !el.textContent || el.textContent.indexOf('※') === -1) return;

    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || node.nodeValue.indexOf('※') === -1) {
          return NodeFilter.FILTER_REJECT;
        }

        var parent = node.parentElement;
        if (!parent || parent.closest('script, style, .footnote-marker')) {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      },
    });
    var nodes = [];
    var node;

    while ((node = walker.nextNode())) {
      nodes.push(node);
    }

    nodes.forEach(function (textNode) {
      var fragment = document.createDocumentFragment();
      var parts = textNode.nodeValue.split('※');

      parts.forEach(function (part, index) {
        if (part) {
          fragment.appendChild(document.createTextNode(part));
        }

        if (index < parts.length - 1) {
          var marker = document.createElement('span');
          marker.className = 'footnote-marker';
          marker.textContent = '※';
          fragment.appendChild(marker);
        }
      });

      textNode.parentNode.replaceChild(fragment, textNode);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(applySupSub);
    });
    applyNoteMarker(document.body);
  });
})();

// NEWS一覧ページャー
(function () {
  var list = document.querySelector('[data-news-pagination-list]');
  var pagination = document.querySelector('[data-news-pagination]');
  if (!list || !pagination) return;

  var desktopQuery = window.matchMedia('(min-width: 1024px)');
  var items = Array.prototype.slice.call(list.querySelectorAll('[data-news-pagination-item]'));
  var pageSize = getPageSize();
  var totalPages = Math.ceil(items.length / pageSize);

  function getPageSize() {
    var attr = desktopQuery.matches ? 'data-page-size-desktop' : 'data-page-size-mobile';
    return parseInt(list.getAttribute(attr), 10) || parseInt(list.getAttribute('data-page-size'), 10) || 10;
  }

  function getPageFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var page = parseInt(params.get('news_page'), 10);
    if (!page || page < 1) return 1;
    return Math.min(page, totalPages);
  }

  function updateUrl(page) {
    var url = new URL(window.location.href);
    if (page === 1) {
      url.searchParams.delete('news_page');
    } else {
      url.searchParams.set('news_page', page);
    }
    window.history.replaceState({}, '', url.toString());
  }

  function createButton(label, page, options) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'page-blog__pagination-link';
    button.textContent = label;
    button.dataset.page = String(page);

    if (options && options.modifier) {
      button.classList.add(options.modifier);
    }
    if (options && options.current) {
      button.classList.add('is-current');
      button.setAttribute('aria-current', 'page');
    }
    if (options && options.disabled) {
      button.classList.add('is-disabled');
      button.disabled = true;
      button.setAttribute('aria-hidden', 'true');
    }
    if (options && options.label) {
      button.setAttribute('aria-label', options.label);
    }

    return button;
  }

  function renderPagination(currentPage) {
    pagination.innerHTML = '';
    pagination.hidden = false;

    pagination.appendChild(createButton('←', currentPage - 1, {
      disabled: currentPage === 1,
      label: '前のページ',
      modifier: 'page-blog__pagination-link--prev',
    }));

    for (var page = 1; page <= totalPages; page += 1) {
      pagination.appendChild(createButton(String(page), page, {
        current: page === currentPage,
        label: page + 'ページ目',
      }));
    }

    pagination.appendChild(createButton('→', currentPage + 1, {
      disabled: currentPage === totalPages,
      label: '次のページ',
      modifier: 'page-blog__pagination-link--next',
    }));
  }

  function showPage(page, shouldScroll) {
    pageSize = getPageSize();
    totalPages = Math.ceil(items.length / pageSize);

    if (totalPages <= 1) {
      items.forEach(function (item) {
        item.hidden = false;
      });
      pagination.innerHTML = '';
      pagination.hidden = true;
      updateUrl(1);
      return;
    }

    var currentPage = Math.min(Math.max(page, 1), totalPages);
    var start = (currentPage - 1) * pageSize;
    var end = start + pageSize;

    items.forEach(function (item, index) {
      item.hidden = index < start || index >= end;
    });

    renderPagination(currentPage);
    updateUrl(currentPage);

    if (shouldScroll) {
      list.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  pagination.addEventListener('click', function (event) {
    var button = event.target.closest('button[data-page]');
    if (!button || button.disabled) return;
    showPage(parseInt(button.dataset.page, 10), true);
  });

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', function () {
      showPage(getPageFromUrl(), false);
    });
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(function () {
      showPage(getPageFromUrl(), false);
    });
  }

  showPage(getPageFromUrl(), false);
})();

// 商品一覧ページャー
(function () {
  var list = document.querySelector('[data-collection-pagination-list]');
  var pagination = document.querySelector('[data-collection-pagination]');
  if (!list || !pagination) return;

  var desktopQuery = window.matchMedia('(min-width: 1024px)');
  var items = Array.prototype.slice.call(list.querySelectorAll('[data-collection-pagination-item]'));
  var pageSize = getPageSize();
  var totalPages = Math.ceil(items.length / pageSize);

  function getPageSize() {
    var attr = desktopQuery.matches ? 'data-page-size-desktop' : 'data-page-size-mobile';
    return parseInt(list.getAttribute(attr), 10) || 8;
  }

  function getPageFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var page = parseInt(params.get('products_page'), 10);
    if (!page || page < 1) return 1;
    return Math.min(page, totalPages);
  }

  function updateUrl(page) {
    var url = new URL(window.location.href);
    if (page === 1) {
      url.searchParams.delete('products_page');
    } else {
      url.searchParams.set('products_page', page);
    }
    window.history.replaceState({}, '', url.toString());
  }

  function createButton(label, page, options) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'page-blog__pagination-link';
    button.textContent = label;
    button.dataset.page = String(page);

    if (options && options.modifier) {
      button.classList.add(options.modifier);
    }
    if (options && options.current) {
      button.classList.add('is-current');
      button.setAttribute('aria-current', 'page');
    }
    if (options && options.disabled) {
      button.classList.add('is-disabled');
      button.disabled = true;
      button.setAttribute('aria-hidden', 'true');
    }
    if (options && options.label) {
      button.setAttribute('aria-label', options.label);
    }

    return button;
  }

  function renderPagination(currentPage) {
    pagination.innerHTML = '';
    pagination.hidden = false;

    pagination.appendChild(createButton('←', currentPage - 1, {
      disabled: currentPage === 1,
      label: '前のページ',
      modifier: 'page-blog__pagination-link--prev',
    }));

    for (var page = 1; page <= totalPages; page += 1) {
      pagination.appendChild(createButton(String(page), page, {
        current: page === currentPage,
        label: page + 'ページ目',
      }));
    }

    pagination.appendChild(createButton('→', currentPage + 1, {
      disabled: currentPage === totalPages,
      label: '次のページ',
      modifier: 'page-blog__pagination-link--next',
    }));
  }

  function showPage(page, shouldScroll) {
    pageSize = getPageSize();
    totalPages = Math.ceil(items.length / pageSize);

    if (totalPages <= 1) {
      items.forEach(function (item) {
        item.hidden = false;
      });
      pagination.innerHTML = '';
      pagination.hidden = true;
      updateUrl(1);
      return;
    }

    var currentPage = Math.min(Math.max(page, 1), totalPages);
    var start = (currentPage - 1) * pageSize;
    var end = start + pageSize;

    items.forEach(function (item, index) {
      item.hidden = index < start || index >= end;
    });

    renderPagination(currentPage);
    updateUrl(currentPage);

    if (shouldScroll) {
      list.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  pagination.addEventListener('click', function (event) {
    var button = event.target.closest('button[data-page]');
    if (!button || button.disabled) return;
    showPage(parseInt(button.dataset.page, 10), true);
  });

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', function () {
      showPage(getPageFromUrl(), false);
    });
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(function () {
      showPage(getPageFromUrl(), false);
    });
  }

  showPage(getPageFromUrl(), false);
})();
